import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import { MutationTree } from "vuex";
import { GlobalSearchState } from "./types";

export const mutations: MutationTree<GlobalSearchState> = {
  setZipCodeSearchCheck(state, payload: boolean) {
    state.zipCodeSearchCheck = payload;
  },
};
